export const materialIconSymbolIds = {
  add: "material-symbol-add",
  archive: "material-symbol-archive",
  arrow_upward: "material-symbol-arrow-upward",
  article: "material-symbol-article",
  assignment: "material-symbol-assignment",
  bar_chart: "material-symbol-bar-chart",
  bolt: "material-symbol-bolt",
  book_2: "material-symbol-book-2",
  branches: "material-symbol-branches",
  bug_report: "material-symbol-bug-report",
  build: "material-symbol-build",
  call: "material-symbol-call",
  call_end: "material-symbol-call-end",
  check: "material-symbol-check",
  checklist: "material-symbol-checklist",
  chevron_left: "material-symbol-chevron-left",
  chevron_right: "material-symbol-chevron-right",
  close: "material-symbol-close",
  code: "material-symbol-code",
  collapse_content: "material-symbol-collapse-content",
  compress: "material-symbol-compress",
  conditions: "material-symbol-conditions",
  content_copy: "material-symbol-content-copy",
  create_new_folder: "material-symbol-create-new-folder",
  crop_free: "material-symbol-crop-free",
  css: "material-symbol-css",
  dashboard: "material-symbol-dashboard",
  dark_mode: "material-symbol-dark-mode",
  data_object: "material-symbol-data-object",
  database: "material-symbol-database",
  delete: "material-symbol-delete",
  description: "material-symbol-description",
  dock_to_left: "material-symbol-dock-to-left",
  dock_to_right: "material-symbol-dock-to-right",
  done_all: "material-symbol-done-all",
  download: "material-symbol-download",
  draft: "material-symbol-drafts",
  edit: "material-symbol-edit",
  edit_square: "material-symbol-edit-square",
  error: "material-symbol-error",
  export: "material-symbol-export",
  expand_content: "material-symbol-expand-content",
  expand_more: "material-symbol-expand-more",
  filter_list: "material-symbol-filter-list",
  fit_screen: "material-symbol-fit-screen",
  folder_open: "material-symbol-folder-open",
  folder_zip: "material-symbol-folder-zip",
  format_text_overflow: "material-symbol-format-text-overflow",
  format_text_wrap: "material-symbol-format-text-wrap",
  front_hand: "material-symbol-front-hand",
  git_fork: "material-symbol-git-fork",
  gpp_maybe: "material-symbol-gpp-maybe",
  help: "material-symbol-help",
  history: "material-symbol-history",
  html: "material-symbol-html",
  hub: "material-symbol-hub",
  image: "material-symbol-image",
  info: "material-symbol-info",
  inventory_2: "material-symbol-inventory-2",
  javascript: "material-symbol-javascript",
  keyboard_arrow_down: "material-symbol-keyboard-arrow-down",
  keyboard_arrow_right: "material-symbol-keyboard-arrow-right",
  keyboard_arrow_up: "material-symbol-keyboard-arrow-up",
  keyboard_return: "material-symbol-keyboard-return",
  light_mode: "material-symbol-light-mode",
  list_arrow: "material-symbol-list-arrow",
  lock: "material-symbol-lock",
  mic: "material-symbol-mic",
  more_horiz: "material-symbol-more-horiz",
  open_in_new: "material-symbol-open-in-new",
  pause_circle: "material-symbol-pause-circle",
  person: "material-symbol-person",
  person_search: "material-symbol-person-search",
  picture_as_pdf: "material-symbol-picture-as-pdf",
  play_circle: "material-symbol-play-circle",
  preview: "material-symbol-preview",
  progress_activity: "material-symbol-progress-activity",
  psychology: "material-symbol-psychology",
  question_answer: "material-symbol-forum",
  redo: "material-symbol-redo",
  refresh: "material-symbol-refresh",
  rename: "material-symbol-rename",
  reply: "material-symbol-reply",
  robot_2: "material-symbol-robot-2",
  rule: "material-symbol-rule",
  save: "material-symbol-save",
  schedule: "material-symbol-schedule",
  search: "material-symbol-search",
  settings: "material-symbol-settings",
  skills: "material-symbol-skills",
  slideshow: "material-symbol-slideshow",
  smart_toy: "material-symbol-smart-toy",
  stop_circle: "material-symbol-stop-circle",
  subject: "material-symbol-subject",
  swap_horiz: "material-symbol-swap-horiz",
  sync_alt: "material-symbol-sync-alt",
  table_chart: "material-symbol-table-chart",
  terminal: "material-symbol-terminal",
  thumb_down: "material-symbol-thumb-down",
  tune: "material-symbol-tune",
  unarchive: "material-symbol-unarchive",
  verified_user: "material-symbol-verified-user",
  visibility: "material-symbol-visibility",
  volume_off: "material-symbol-volume-off",
  volume_up: "material-symbol-volume-up",
  warning: "material-symbol-warning",
  zoom_in: "material-symbol-zoom-in",
  zoom_out: "material-symbol-zoom-out",
} as const;

export type MaterialIconName = keyof typeof materialIconSymbolIds;

export const MATERIAL_ICON_NAMES = Object.keys(
  materialIconSymbolIds,
) as MaterialIconName[];

export function isMaterialIconName(name: string): name is MaterialIconName {
  return Object.prototype.hasOwnProperty.call(materialIconSymbolIds, name);
}

export function resolveMaterialIconName(name: string): MaterialIconName {
  return isMaterialIconName(name) ? name : "help";
}

export function getMaterialIconSymbolId(name: MaterialIconName): string {
  return materialIconSymbolIds[name];
}
